import { StyleSheet, View, ScrollView } from 'react-native';
import { useThemeColor } from '@/hooks/useThemeColor';
import { useWindowStore } from '@/stores/useWindowStore';
import { forwardRef } from 'react';
import { trans } from '@/helper/Translation';

export const CoreView = forwardRef((props, ref) => {

    const {
        style, 
        light = null, 
        dark = null, 
        type = 'default', 
        inverted = false, 
        noSwitch = false,
        scollable = false,
        hoverTitle = null,
        center = false,
        hideOn = [],
        children,
        ...rest
    } = props;
    
    const group = useWindowStore((s) => s.group);

    const backgroundColor = useThemeColor({ light: inverted ? dark : light, dark: inverted ? light : dark }, 'background');
    
    if (hideOn?.includes(group)) 
        return null;

    const hoverTitleText = typeof hoverTitle === 'string' ? trans(hoverTitle) : null;

    const filteredChildren = Array.isArray(children) 
        ? children.filter(child => child != null && child !== false) 
        : children;

    const ViewComp = scollable ? ScrollView : View;
    const _style = StyleSheet.create({
        base: {
            justifyContent: center ? 'center' : undefined, 
            alignItems: center ? 'center' : style?.alignItems,
            ...StyleSheet.flatten(style)
        },
    });

    if (noSwitch) 
        return (
            <ViewComp 
                accessibilityLabel={hoverTitleText}
                ref={ref} 
                style={_style.base} 
                {...rest} 
            >{filteredChildren}</ViewComp>
        );

    
    const _styleWithBg = StyleSheet.create({
        base: StyleSheet.flatten([
            _style.base,
            {backgroundColor}
        ]),
    });
    

    return (
        <ViewComp 
            accessibilityLabel={hoverTitleText}
            className={'View'} 
            ref={ref} 
            style={_styleWithBg.base} 
            {...rest} 
        >{filteredChildren}</ViewComp>
    );
});